import type { FC } from 'react';

import type { Editor } from '@tiptap/react';

import { FormatButtons } from './FormatButtons';

interface FormatSubBarProps {
  editor: Editor;
  translations?: Record<string, string>;
}

export const FormatSubBar: FC<FormatSubBarProps> = (props) => (
  <div className="border-b border-black/10 py-2 pl-3 pr-4">
    <FormatButtons {...props} />
  </div>
);
